<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Nova pré-autorização</span>
      </h1>
      <div>
        <PrimaryButton @click="submit()" class="px-5" icon="fa-solid fa-paper-plane">Enviar</PrimaryButton>
      </div>
    </div>
  </div>

  <div class="align p-4 space_title">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <InputText label="Título" v-model="preAuthorization.title" :error="formErrors.title" />
              </div>

              <div class="col-12 col-md-6 mb-3">
                <InputText label="Referência G1" v-model="preAuthorization.reference_g1" :error="formErrors.reference_g1" />
              </div>

              <div class="col-12 col-md-6 mb-3">
                <InputText label="Referência UOL" v-model="preAuthorization.reference_uol" :error="formErrors.reference_uol" />
              </div>

              <div class="col-12 col-md-6 mb-3">
                <InputText label="Referência R7" v-model="preAuthorization.reference_r7" :error="formErrors.reference_r7" />
              </div>

              <div class="col-12 col-md-6 mb-3">
                <InputText label="Referência Metrópoles" v-model="preAuthorization.reference_metropoles" :error="formErrors.reference_metropoles" />
              </div>

              <div class="col-12 col-md-6 mb-3">
                <InputText label="Outra Referência" v-model="preAuthorization.reference_other" :error="formErrors.reference_other" />
              </div>

              <div class="col-12 col-md-6 mb-3">
                <InputText label="Segunda Referência" v-model="preAuthorization.reference_other_two" :error="formErrors.reference_other_two" />
              </div>

              <div class="col-12 mb-3">
                <TextArea label="Observações" v-model="preAuthorization.observation" :error="formErrors.observation" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card">
          <div class="p-4">
            <ImageUpload label="Imagem" v-model="preAuthorization.image" :error="formErrors.image" />
            <div class="mt-3">
              <InputText label="Referência da Imagem" v-model="preAuthorization.image_reference" :error="formErrors.image_reference" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import TextArea from '@/components/TextArea.vue'
import ImageUpload from '@/components/ImageUpload.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import { usePreAuthorizationStore } from '@/stores/PreAuthorizationStore'
import { inject, onMounted, ref } from 'vue';
import { useToast, TYPE } from "vue-toastification";
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import {errorFormat} from "@/utils/errorFormat";
const toast = useToast();

const loader = inject('$loader');

const formErrors = ref({});

const preAuthorizationStore = usePreAuthorizationStore();
const { preAuthorization } = storeToRefs(preAuthorizationStore);

const router = useRouter();

onMounted(async () => {
  preAuthorizationStore.preAuthorization = {};
});

const submit = async () => {
  let params = {
    title: preAuthorizationStore.preAuthorization.title,
    reference_g1: preAuthorizationStore.preAuthorization.reference_g1,
    reference_uol: preAuthorizationStore.preAuthorization.reference_uol,
    reference_r7: preAuthorizationStore.preAuthorization.reference_r7,
    reference_metropoles: preAuthorizationStore.preAuthorization.reference_metropoles,
    reference_other: preAuthorizationStore.preAuthorization.reference_other,
    reference_other_two: preAuthorizationStore.preAuthorization.reference_other_two,
    observation: preAuthorizationStore.preAuthorization.observation,
    image: preAuthorizationStore.preAuthorization.image,
    image_reference: preAuthorizationStore.preAuthorization.image_reference,
  };

  loader.show();
  formErrors.value = {};

  const formResult = await preAuthorizationStore.addPreAuthorization(params);
  if (formResult.success) {
    toast('Pré-autorização criada', { type: TYPE.SUCCESS, timeout: 6000 });
    router.push({ name: 'preAuthorization', params: { id: preAuthorizationStore.preAuthorization.id } });
  }
  else {
    formErrors.value = errorFormat(formResult.errors);
  }

  loader.hide();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}
</style>